<template>
    <div class="head-mobile">
        <div class="head-mobile-left">
            <img src="../assets/images/icon-back-black.svg" alt="logo" @click="goBack" class="icon-back" />
            <p>{{ title }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeadMobileComp',
    props: {
        title: {
            type: String,
            required: true,
            default: 'Title'
        }
    },
    methods: {
        goBack() {
            this.$router.back();
        }
    }
}
</script>

<style scoped>
.head-mobile {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    background-color: var(--white-color);
}

.head-mobile p {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    text-align: center;
    color: #076C71;
    margin-bottom: 0;
}

.icon-back {
    width: 15px;
    height: 15px;
    position: absolute;
    left: 25px;
    top: 13px;
}
</style>